export default {
  Main: {
    service: 'SERVICIOS',
    work: 'TRABAJOS',
    location: 'UBICACIÓN',
    home: 'INICIO',
  },
  Headers: {
    description:
      '¡Lo mejor para limpiar tus piscinas! No más colores extraños y objetos no deseados, solo agua azul relajante.',
    cta: 'Contáctanos',
  },
  Services: {
    title: 'Servicios',
    spa: {
      title: 'Servicios de Spa',
      description: 'Limpieza y mantenimiento del agua',
    },
    treatment: {
      title: 'Tratamiento',
      description: 'Eliminar verde alga  y negro alga',
    },
    acid: {
      title: 'Tratamiento de ácido',
      description: 'Sepillado y enjuague con agua y ácido',
    },
    salt: {
      title: 'Sistema de Sal',
      description: 'Tratamiento de agua control de sal y limpieza  de sistema de sal',
    },
    blacksmith: {
      title: 'Ventas de equipo',
      description: 'Herrer filtro motor y sistema de sal',
    },
    installation: {
      title: 'Instalación',
      description: 'Filtro, motor, herrer y sistema de sal',
    },
    repair: {
      title: 'Reparación',
      description: 'Filtro, reparación herrer, luz, aspiradora motor y sistema de sal',
    },
  },
  Works: {
    title: 'Trabajos',
    before: 'Antes',
    after: 'Despues',
  },
  Location: {
    title: 'Ubicación',
  },
  Footer: {
    description: 'Estamos para ayudarte',
    footer: 'Todos los derechos reservados',
  },
}
